module.exports = __webpack_public_path__ + "img/PaymentSuccessful.d8b94e28.jpeg";